export default __webpack_public_path__ + "static/media/appOverview.926a9a91.png";